import { NgModule } from '@angular/core';
import { UserPermissionComponent } from './userpermission.component';
import { TnxSharedModule } from 'tnx-shared';
import { AngularSplitModule } from 'angular-split';
import { UserPermissionRoutes } from './userpermission.routing';
import { UserRoleComponent } from './user-role/user-role.component';
import { UserPermissionFilterComponent } from './user-permission-filter/user-permission-filter.component';
import { UserPermissionAreaComponent } from './user-permission-area/user-permission-area.component';
import { UserGroupContainUserComponent } from './user-group-contain-user/user-group-contain-user.component';
import { RoleModule } from 'tnx-admin-service/authorization/role';
import { UserGroupModule } from 'tnx-admin-service/authorization/usergroup';
import { ClientManagementModule } from 'tnx-admin-service/client-management';

export function declaration() {
    return [
        UserPermissionComponent,
        UserPermissionAreaComponent,
        UserPermissionFilterComponent,
        UserRoleComponent,
        UserGroupContainUserComponent
    ];
}

@NgModule({
    imports: [
        TnxSharedModule,
        AngularSplitModule,
        RoleModule,
        UserGroupModule,
        ClientManagementModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class UserPermissionModule {
}

@NgModule({
    imports: [UserPermissionModule, UserPermissionRoutes],
    exports: [UserPermissionModule]
})
export class UserPermissionWithRouteModule {
}
